/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm, disable} from '@insticator/insticator-ui';


/* ++++++++++ --------------- SENTIMENT - GET CODE PAGE : STYLES --------------- ++++++++++ */
export default {
  sentimentcode: {
    '&.isDisabled': {
      '&-true': {
        extend: disable
      }
    },
    '& .subtitle': {
      color: 'rgb(130, 149, 186)',
    },

    '&  .codemessage': {
      padding: '2em 0'
    }
  }
};
